import React from "react";
import { Row, Spinner } from "@masterteam/mt-design-react";

import styles from "./AdminPage.module.scss";

function AdminPage({ title, children, loading }) {
  return (
    <div className={styles.adminPage}>
      <div className={styles.title}>{title}</div>
      {loading ? (
        <Row justify="center" align="center" className={styles.loading}>
          <Spinner size="large" />
        </Row>
      ) : (
        children
      )}
    </div>
  );
}

export default AdminPage;
